import { useEffect, useMemo, useState, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { getGroupById } from "../../../../store/actions/group";

import { Link as RrdLink } from "react-router-dom";
import LinkUi from "../../../../components/Link";
import Dropdown from "../../../../components/DropdownBis";


import {
  getFeaturedPosts,
  getScheduledPosts,
  resetGetFeaturedPosts,
  resetGetPosts,
  resetGetScheduledPosts,
  resetSetFeaturedPost,
} from "../../../../store/actions/post";
import MembershipTabs from "../../Membership/components/Tabs";
import ExperienceTabs from "../../Experience/components/Tabs";
import CommunityTabs from "../../Community/components/Tabs";
import { getAllCategories, resetNewCategory, resetUpdateCategory } from "../../../../store/actions/category";
import { useLayout } from "../../../../providers/LayoutProvider";
import Grid from "../../../../components/Grid";
import CallToAction from "../../components/CallToAction";
import Snackbar from "../../../../components/Snackbar";
import Category from "../../Category";
import ModalShareLink from "../../components/ModalShareLink";
import ModalConfirmDelete from "../components/ModalConfirmDelete";
import PinnedArticlesList from "./components/PinnedArticlesList";
import ScheduledArticlesList from "./components/ScheduledArticlesList";
import ArticlesList from "./components/ArticlesList";
import ReorderPinedPostsSidebar from "./components/ReorderPinedPostsSidebar";
import postIcon from "../../../../assets/icons/post-icon.svg";
import categoryIcon from "../../../../assets/icons/category-icon.svg";
import sortIcon from "../../../../assets/icons/sort-icon.svg";
import { CategoryDto } from "../../../../types/category";
import { Post } from "../../../../types/post";
import FloatingMenu from "./components/FloatingMenu";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { showModal } from "../../../../store/actions/modal";
import DoorStatusBadge from "../../components/DoorStatusBadge";

const Component = ({
  group,
  groupStates,
  featuredPosts,
  featuredPostsStates,
  scheduledPostsStates,
  allCategories,
  match,
  setFeaturedPostStates,
  isLoggedIn,
  newCategory,
  newCategoryStates,
  updatedCategoryStates,
}) => {
  const { isMobile } = useWindowSize()
  const dispatch = useDispatch();
  const { layout, setLayout } = useLayout();
  const [unpinedItem, setUnpinedItem] = useState(null);
  const [idArticleToDelete, setIdArticleToDelete] = useState<Post>();
  const [categoryManagerVisible, setCategoryManagerVisible] = useState<boolean>(false);
  const [createNewCategorySidebarVisible, setCreateNewCategorySidebarVisible] = useState<boolean>(false);
  const [reorderContentSidebarVisible, setReorderContentSidebarVisible] = useState<boolean>(false);
  const [editCategorySidebarVisible, setEditCategorySidebarVisible] = useState<boolean>(false);
  const [idCategoryToOrder, setIdCategoryToOrder] = useState<number>();
  const [categoryToEdit, setCategoryToEdit] = useState<CategoryDto>();
  const [showReorderPinedPostsSidebarVisible, setShowReorderPinedPostsSidebarVisble] = useState<boolean>(false);

  const isRestrictedGroup = useMemo(() => {
    return !!group && group.group_type !== "community" && group.group_type !== "free_experience";
  }, [group]);

  const initPage = useCallback(() => {
    if (!group) return;

    const isExperience = group.group_type === "experience";
    const isMembership = group.group_type === "membership";
    const isFreeExperience = group.group_type === "free_experience";

    const shouldLoadScheduledPosts = isExperience || isMembership || isFreeExperience;
    const shouldLoadFeaturedPosts = isExperience || isMembership;

    if (shouldLoadScheduledPosts) {
      dispatch(getScheduledPosts({
        pagination: {
          _sort: "asc",
          _sort_by: "schedule_publish_at",
          page: 1,
          per_parge: 12,
        },
        filters: { group_id: group.id },
      }));
    }

    if (shouldLoadFeaturedPosts) {
      dispatch(getFeaturedPosts({
        pagination: { _sort: "asc", _sort_by: "pinned_order" },
        filters: { group_id: group.id },
      }));
    }

    dispatch(getAllCategories({
      group_id: group.id,
      with_posts: true,
      only_showable_posts: false,
      posts_per_category: 8,
      sort_by: "category_order:asc",
      include_empty_cats_in_ordinal: true,
      enrich_unlockable_data_for_user: true
    }));
  }, [group, dispatch]);

  useEffect(() => {
    const idGroup = Number(match?.params?.idGroup);
    const needsFetch = !group || group?.id !== idGroup;
    if (idGroup && needsFetch && !groupStates.loading) {
      dispatch(getGroupById({ group_id: idGroup }));
    }
  }, [match?.params?.idGroup, group, groupStates.loading, dispatch]);

  useEffect(() => {
    if (group) initPage();
  }, [group]);

  useEffect(() => {
    return () => {
      dispatch(resetGetPosts());
      dispatch(resetGetScheduledPosts());
      dispatch(resetGetFeaturedPosts());
    };
  }, [isLoggedIn]);

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {group?.group_name}
          </div>
        ),
        subtitle: <DoorStatusBadge group={group} />,
        description: "Listado de artículos",
        // back: `/dashboard/${group?.group_type === 'free_experience' ? 'community/events' : group?.group_type}/${group?.group_type === "community"
        //   ? ""
        //   : group?.id
        //   }`,
        back: undefined,
      },
      dashboard: {
        tabs: {
          visible: !!group,
          activeTab: "home",
          component: [
            group?.group_type === 'community' ?
              <CommunityTabs active="library" /> :
              group?.type === 'membership' ?
                <ExperienceTabs active="library" /> :
                <MembershipTabs active="library" />
          ],
        },
      },
      header: {
        visible: !!group,
        actions: !isMobile ? [
          ...(group?.group_type !== 'community' ? [
            <Dropdown>
              <RrdLink
                to={`/group/${group?.slug}/library`}
                key={'go-to-preview-btn'}
                target="_blank"
              >
                Vista previa
              </RrdLink>

              <button
                disabled={group?.status === 'draft'}
                onClick={() => {
                  const link = `${process.env.REACT_APP_SITE_BASE_URL}/group/${group?.slug}`;
                  navigator.clipboard.writeText(link);
                  dispatch(showModal("modal-share-group-link"));
                }}
                key={'share-experience-btn'}
              >
                Compartir taller
              </button>
            </Dropdown>
          ] : []),
          < LinkUi
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
              native: true,
            }}
            href={
              group?.group_type === "free_experience"
                ? `/dashboard/community/events/${group?.id}/posts/v2/new`
                : `/dashboard/${group?.group_type}/${group?.id}/posts/v2/new`
            }
            style={group?.group_type === "community" ? { minWidth: "210px" } : {}}
          >
            {group?.group_type === "community"
              ? "Crear contenido gratuíto"
              : "Crear contenido"}
          </LinkUi >,
        ] : [],
      },
      show_whatsapp: false,
    });
  }, [group, isMobile]);

  useEffect(() => {
    if (newCategoryStates.success) {
      setCreateNewCategorySidebarVisible(false)

      setTimeout(() => {
        dispatch(resetNewCategory());
      }, 3500);
    }

    if (newCategoryStates.error) {
      setTimeout(() => {
        dispatch(resetNewCategory());
      }, 3500);
    }
  }, [newCategoryStates]);

  useEffect(() => {
    if (updatedCategoryStates.success) {
      setCategoryToEdit(undefined)

      setTimeout(() => {
        dispatch(resetUpdateCategory());
      }, 3500);
    }

    if (updatedCategoryStates.error) {
      setTimeout(() => {
        dispatch(resetUpdateCategory());
      }, 3500);
    }
  }, [updatedCategoryStates]);

  return (
    <>
      {!isMobile && isRestrictedGroup && (
        <>
          <Grid.Container>
            <Grid.Row>
              <Grid.Col md={4}>
                <CallToAction
                  title="Subir nuevo artículo"
                  link={`/dashboard/${group?.group_type}/${group?.id}/posts/v2/new`}
                  options={{ size: "small", preffix: postIcon }}
                />
              </Grid.Col>
              <Grid.Col md={4}>
                <CallToAction
                  title="Crear nueva categoría"
                  action={() => setCreateNewCategorySidebarVisible(true)}
                  options={{ size: "small", preffix: categoryIcon }}
                />
              </Grid.Col>
              <Grid.Col md={4}>
                <CallToAction
                  title="Administrar categorías"
                  action={() => setCategoryManagerVisible(true)}
                  options={{ size: "small", preffix: sortIcon }}
                />
              </Grid.Col>
            </Grid.Row>
          </Grid.Container>

          <div style={{ height: 24 }} />
        </>
      )}


      {isRestrictedGroup && (
        <>
          <ScheduledArticlesList />

          <PinnedArticlesList
            setShowReorderPinedPostsSidebarVisble={setShowReorderPinedPostsSidebarVisble}
            setUnpinedItem={setUnpinedItem}
            setIdArticleToDelete={setIdArticleToDelete}
          />
        </>
      )}

      <ArticlesList
        setReorderContentSidebarVisible={setReorderContentSidebarVisible}
        setEditCategorySidebarVisible={setEditCategorySidebarVisible}
        setUnpinedItem={setUnpinedItem}
        setIdCategoryToOrder={setIdCategoryToOrder}
        setCategoryToEdit={setCategoryToEdit}
        setIdArticleToDelete={setIdArticleToDelete}
      />

      <Snackbar
        visible={
          setFeaturedPostStates.success ||
          !!setFeaturedPostStates.error ||
          setFeaturedPostStates.loading
        }
        options={{
          time: 500,
          type: setFeaturedPostStates.success
            ? "success"
            : setFeaturedPostStates.loading
              ? "info"
              : "error",
        }}
        onHide={() => dispatch(resetSetFeaturedPost())}
      >
        {setFeaturedPostStates.success && "Accion realizada exitosamente!"}
        {setFeaturedPostStates.error && "Error al destacar el artículo."}
      </Snackbar>

      <ModalShareLink />

      <ModalConfirmDelete idArticle={idArticleToDelete} />

      <Category
        idCategoryToOrder={idCategoryToOrder}
        categoryToEdit={categoryToEdit}
        showReorderContent={reorderContentSidebarVisible}
        showCategories={categoryManagerVisible}
        showCreateCategory={createNewCategorySidebarVisible}
        setCategoryManagerVisible={setCategoryManagerVisible}
        onClose={() => {
          setCategoryToEdit(undefined);
          setIdCategoryToOrder(undefined);
          setReorderContentSidebarVisible(false);
          setEditCategorySidebarVisible(false);
          setCreateNewCategorySidebarVisible(false);
        }}
      />

      <ReorderPinedPostsSidebar
        onClose={() => {
          setShowReorderPinedPostsSidebarVisble(false)
        }}
        isVisible={showReorderPinedPostsSidebarVisible}
      />

      {isMobile && (
        <FloatingMenu
          setCategoryManagerVisible={setCategoryManagerVisible}
          setCreateNewCategorySidebarVisible={setCreateNewCategorySidebarVisible}
        />
      )}

      <Snackbar
        visible={newCategoryStates.success || !!newCategoryStates.error}
        options={{
          time: 2000,
          type: newCategoryStates.success ? "success" : "error",
        }}
      >
        {newCategoryStates.success
          ? "Categoría creada."
          : "Error al crear la categoría."}
      </Snackbar>


      <Snackbar
        visible={updatedCategoryStates.success || !!updatedCategoryStates.error}
        options={{
          time: 2000,
          type: updatedCategoryStates.success ? "success" : "error",
        }}
      >
        {updatedCategoryStates.success
          ? "Categoría actualizada."
          : "Error al actualizar la categoría."}
      </Snackbar>
    </>
  );
};

const state = ({ groupStore, postStore, categoryStore, userStore }) => {
  const { data: newCategory, states: newCategoryStates } = categoryStore.newCategory;
  const { data: updatedCategory, states: updatedCategoryStates } = categoryStore.updateCategory;

  return {
    group: groupStore.group.data,
    groupStates: groupStore.group.states,
    featuredPosts: postStore.featuredPosts.data,
    featuredPostsStates: postStore.featuredPosts.states,
    scheduledPostsStates: postStore.scheduledPosts.states,
    setFeaturedPostStates: postStore.setFeaturedPost.states,
    allCategories: categoryStore.allCategories.data,
    isLoggedIn: userStore.isLoggedIn,
    newCategory,
    newCategoryStates,
    updatedCategory,
    updatedCategoryStates
  };
};

export default connect(state)(Component);
